// extracted by mini-css-extract-plugin
export default {"copyPoll":"CopyPollModal_copyPoll__evnJN"};